import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n'], ['\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n']),
    _templateObject2 = _taggedTemplateLiteral([''], ['']);

import styled from 'styled-components';
// import { gridSize, fontSize, colors, themed } from '@atlaskit/theme';
/*
* TODO: Implement using SC 2+ attrs and properly handle:
* - inline
* - full page
* - within Modal Dialog
*/

/**
 * Provide a styled container with form as default.
 */
var FormWrapper = styled.div(_templateObject);

/**
 * Provide a styled container with form as default.
 */
var FormContent = styled.form(_templateObject2);

export default FormWrapper;
export { FormContent };